import type { TranslationKey } from "../locales";
import type { WebfleetOrderState } from "../types";

/**
 * This function maps Webfleet order states to translation keys.
 * @param state - The Webfleet order state.
 * @returns The corresponding translation key.
 */
export function getWebfleetOrderStateTranslationKey(state: WebfleetOrderState): TranslationKey {
	switch (state) {
		case 0:
			return "webfleet.order_states.not_yet_sent";
		case 100:
			return "webfleet.order_states.sent";
		case 101:
			return "webfleet.order_states.received";
		case 102:
			return "webfleet.order_states.read";
		case 103:
			return "webfleet.order_states.accepted";
		case 201:
			return "webfleet.order_states.service_order_started";
		case 202:
			return "webfleet.order_states.arrived_at_destination";
		case 203:
			return "webfleet.order_states.work_started";
		case 204:
			return "webfleet.order_states.work_finished";
		case 205:
			return "webfleet.order_states.departed_from_destination";
		case 207:
			return "webfleet.order_states.proof_of_delivery";
		case 221:
			return "webfleet.order_states.pickup_order_started";
		case 222:
			return "webfleet.order_states.arrived_at_pickup_location";
		case 223:
			return "webfleet.order_states.pickup_started";
		case 224:
			return "webfleet.order_states.pickup_finished";
		case 225:
			return "webfleet.order_states.departed_from_pickup_location";
		case 227:
			return "webfleet.order_states.proof_of_delivery";
		case 241:
			return "webfleet.order_states.delivery_order_started";
		case 242:
			return "webfleet.order_states.arrived_at_delivery_location";
		case 243:
			return "webfleet.order_states.delivery_started";
		case 244:
			return "webfleet.order_states.delivery_finished";
		case 245:
			return "webfleet.order_states.departed_from_delivery_location";
		case 247:
			return "webfleet.order_states.proof_of_delivery";
		case 298:
			return "webfleet.order_states.resumed";
		case 299:
			return "webfleet.order_states.suspended";
		case 301:
			return "webfleet.order_states.cancelled";
		case 302:
			return "webfleet.order_states.rejected";
		case 401:
			return "webfleet.order_states.finished";
	}
}
